import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Alert,
  Box,
  InputAdornment
} from "@mui/material";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import { useAuth } from "../../context/AuthContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function AddEmployerDialog({ open, onClose, onSave }) {
  const { user } = useAuth(); // ⬅ Now always up-to-date
  const loginUserRoleId = user?.roleId;
  const loginUserId = user?.userId;

  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [prefix, setPrefix] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [employerName, setEmployerName] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {

    if (!fullName || !password || !employerName || !mobile || !prefix) {
      setError("All fields are required");
      return;
    }

    if (password.length < 4) {
      setError("Password must be at least 4 characters");
      return;
    }

    setSaving(true);

    try {
      const res = await axiosInstance.post("/employers", {
        fullName,
        password,
        employerName,
        prefix,
        mobile
      });

      toast.success(res?.data?.message || "Employer created successfully");

      onSave();
      onClose();

      // Reset form
      setFullName("");
      setPassword("");
      setEmployerName('')
      setPrefix('')
      setMobile('')
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add employee");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Employer</DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box display="grid" gap={2}>
          <TextField
            required
            label="Business Name"
            fullWidth
            margin="normal"
            value={employerName}
            onChange={(e) => setEmployerName(e.target.value)}
          />

          <TextField
            required
            label="Full Name"
            fullWidth
            margin="normal"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />

          <TextField
            label="Mobile Number"
            name="mobile"
            fullWidth
            required
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">🇮🇳 +91</InputAdornment>
              ),
              inputMode: "numeric",
            }}
            inputProps={{
              minLength: 10,
              maxLength: 10,
              pattern: "[0-9]{10}",
            }}
          />

          <TextField
            required
            label="Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                  {!showPassword ? (
                    <VisibilityIcon onClick={() => setShowPassword(true)} />
                  ) : (
                    <VisibilityOffIcon onClick={() => setShowPassword(false)} />
                  )}
                </InputAdornment>
              ),
            }}
          />

          <TextField
            required
            label="Prefix"
            fullWidth
            margin="normal"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
          />

        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
